import { Component, OnInit, Inject } from "@angular/core";

import c = require("../core/competencetypes.dataservice");
import cg = require("../core/competencegroups.dataservice");
import p = require("../core/persons.dataservice");
import w = require("../core/workgroups.dataservice");
import wp = require("../core/workgrouppersons.dataservice");
import search = require("../core/search.dataservice");

import * as dataCore from "../core/datacore";

@Component({
    selector: "crew-search-competences",
    template: require('./competence-search.component.html')
})
export class CompetenceSearchComponent implements OnInit {

    constructor(
        @Inject(p.PersonDataService.Id) private personService: p.PersonDataService,
        @Inject(w.WorkGroupsDataService.Id) private workgroupService: w.WorkGroupsDataService,
        @Inject(wp.WorkgroupPersonDataService.Id) private workgroupPersonService: wp.WorkgroupPersonDataService,
        @Inject(cg.CompetenceGroupsService.Id) private competenceGroupService: cg.CompetenceGroupsService,
        @Inject(c.CompetenceTypeDataService.Id) private competenceTypeService: c.CompetenceTypeDataService,
        @Inject(search.SearchService.Id) private searchService: search.SearchService,
        @Inject("$q") private $q: ng.IQService,
        @Inject("$log") private $log: ng.ILogService) { }

    ngOnInit() {
        this.isLoading = true;

        this.$q
            .all([
                this.competenceGroupService.getAll(),
                this.workgroupPersonService.getAll(),
                this.competenceTypeService.getAll(),
                this.personService.getAll(),
                this.workgroupService.getAll()
            ])
            .then(res => {
                this.competenceGroups = res[0].filter(e => e.Active);
                this.compentenceTypes = res[2].filter(e => e.Active);
                this.persons = res[3].filter(e => e.Active);
                this.workgroups = res[4].filter(e => e.Active);
                this.isLoading = false;
            })
            .catch(err => {
                this.$log.error(err);
                this.isLoading = false;
            });
    }

    public competenceGroups: Nema.Crew.Model.CompetenceGroup[];

    public compentenceTypes: Nema.Crew.Model.CompetenceType[];

    public selectedCompentenceTypes: Nema.Crew.Model.CompetenceType[] = [];

    public persons: Nema.Crew.Model.Person[];

    public workgroups: Nema.Crew.Model.WorkGroup[];

    public selectedPersons: Nema.Crew.Model.Person[] = [];

    public dateFilter: Date = dataCore.getToday();

    public includeExpired: boolean;

    public includeFuture: boolean;

    public selectedresultingPerson: Nema.Crew.Model.PersonWithRelevantCompetences;

    public resultingPersons: Nema.Crew.Model.PersonWithRelevantCompetences[] = [];

    public isLoading: boolean = false;

    public onResultingPersonSelected(person: Nema.Crew.Model.PersonWithRelevantCompetences) {
        this.selectedresultingPerson = person;
    }

    public getCompetenceTypes(competenceGroup: Nema.Crew.Model.CompetenceGroup): Nema.Crew.Model.CompetenceType[] {
        return competenceGroup.CompetenceTypes.filter(e => e.Active);
    }

    public getCompetenceTypeDisplayName(compentenceType: Nema.Crew.Model.CompetenceType): string {
        return compentenceType.Name;
    }

    public search() {

        // Clear the result, before performing the search
        this.resultingPersons = [];
        this.selectedresultingPerson = null;
        this.isLoading = true;

        // Construct the query object
        var personCompetenceQuery: search.PersonCompetenceQuery = {
            PersonIds: this.selectedPersons.map(person => person.Id),
            CompetenceIds: this.selectedCompentenceTypes.map(competence => competence.Id),
            IncludeExpired: this.includeExpired,
            IncludeFuture: this.includeFuture,
            Date: dataCore.subtractTimezoneOffset(this.dateFilter)
        };

        // Make the search
        this.searchService
            .searchPersonCompetences(personCompetenceQuery)
            .then(res => {
                this.resultingPersons = res;
                this.isLoading = false;
            })
            .catch(error => {
                this.$log.error(error);
                this.isLoading = false;
            });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/compliance/competence-search.component.ts